import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  GetADECheckConnection,
  getADECheckConnection,
} from '../api/get-ade-check-connection';
import {
  GetXPMCheckConnection,
  getXPMCheckConnection,
} from '../api/get-xpm-check-connection';

type QueryOptions<
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
> = Omit<
  UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
  'queryKey' | 'queryFn'
>;

type ConnectionType = 'ADE' | 'XPM' | null;

export const useGetConnection = (
  type: ConnectionType,
  queryOptions?: QueryOptions<
    GetADECheckConnection['return'] | GetXPMCheckConnection['return']
  >,
) => {
  const query = useQuery({
    ...queryOptions,
    queryKey: ['getConnection', type],
    queryFn: type === 'ADE' ? getADECheckConnection : getXPMCheckConnection,
    enabled: !!type, // Only run the query if type is provided
  });

  return query;
};
